import { render, staticRenderFns } from "./CFormSummary.vue?vue&type=template&id=13508735&scoped=true&"
import script from "./CFormSummary.vue?vue&type=script&lang=js&"
export * from "./CFormSummary.vue?vue&type=script&lang=js&"
import style0 from "./CFormSummary.vue?vue&type=style&index=0&id=13508735&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13508735",
  null
  
)

export default component.exports